"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClientDiscounts = void 0;
var parse_1 = __importDefault(require("parse"));
var moment_1 = __importDefault(require("moment"));
function getClientDiscounts(CLKTCODE) {
    return __awaiter(this, void 0, void 0, function () {
        var clientId, groupId, tradeNameId, now;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, new parse_1.default.Query("Clients")
                        .equalTo("CLKTCODE", CLKTCODE)
                        .first()];
                case 1:
                    clientId = (_b.sent()).id;
                    return [4 /*yield*/, new parse_1.default.Query("Groups")
                            .equalTo("clients.objectId", clientId)
                            .first()];
                case 2:
                    groupId = ((_b.sent()) || {}).id;
                    return [4 /*yield*/, new parse_1.default.Query("Tradenames")
                            .equalTo("clients.objectId", clientId)
                            .first()];
                case 3:
                    tradeNameId = ((_b.sent()) || {}).id;
                    now = moment_1.default();
                    return [4 /*yield*/, parse_1.default.Query.or(
                        // query for all clients
                        new parse_1.default.Query("Discounts")
                            .limit(1000000)
                            .include("minQuantityProduct", "freeProduct", "product")
                            .equalTo("allClients", true), (_a = parse_1.default.Query).or.apply(_a, __spreadArrays([
                            // query for client
                            new parse_1.default.Query("Discounts")
                                .limit(1000000)
                                .include("minQuantityProduct", "freeProduct", "product")
                                .contains("includedClients.objectId", clientId)
                        ], (groupId
                            ? [
                                new parse_1.default.Query("Discounts")
                                    .limit(1000000)
                                    .include("minQuantityProduct", "freeProduct", "product")
                                    .contains("includedGroups.objectId", groupId),
                            ]
                            : []), (tradeNameId
                            ? [
                                new parse_1.default.Query("Discounts")
                                    .limit(1000000)
                                    .include("minQuantityProduct", "freeProduct", "product")
                                    .contains("includedTradeNames.objectId", tradeNameId),
                            ]
                            : [])))).filter(function (obj) {
                            var _a, _b, _c;
                            var discount = obj.attributes;
                            return !(
                            // filter on dates
                            (moment_1.default(discount.startDate).isAfter(now) ||
                                moment_1.default(discount.endDate).isBefore(now) || ((_a = 
                            // filter on clients, groups & trade names
                            discount.excludedClients) === null || _a === void 0 ? void 0 : _a.some(function (client) { return client.objectId === clientId; })) ||
                                (groupId && ((_b = discount.excludedGroups) === null || _b === void 0 ? void 0 : _b.some(function (_a) {
                                    var objectId = _a.objectId;
                                    return objectId === groupId;
                                }))) ||
                                (tradeNameId && ((_c = discount.excludedTradeNames) === null || _c === void 0 ? void 0 : _c.some(function (_a) {
                                    var objectId = _a.objectId;
                                    return objectId === tradeNameId;
                                })))));
                        })];
                case 4: return [2 /*return*/, (_b.sent()).map(function (_a) {
                        var attributes = _a.attributes;
                        // remove props
                        var _b = attributes, lastUpdater = _b.lastUpdater, updatedAt = _b.updatedAt, createdAt = _b.createdAt, creator = _b.creator, discount = __rest(_b, ["lastUpdater", "updatedAt", "createdAt", "creator"]);
                        // format discounts value & keep max
                        return __assign(__assign({}, discount), { percentageDiscount: discount.percentageDiscount
                                ? Number(discount.percentageDiscount)
                                : undefined, minQuantityProductId: discount.minQuantityProduct
                                ? discount.minQuantityProduct.map(function (product) { return product.objectId; })
                                : undefined });
                    })];
            }
        });
    });
}
exports.getClientDiscounts = getClientDiscounts;
